import type { Dict } from "./pl.js";

export const it: Dict = {
  navCats: "Categorie",
  navHow: "Come funziona",
  navOps: "Per gli operatori",
  navPrice: "Prezzi",
  navContact: "Contatti",
  navBook: "Demo del pannello operatore",
  pill: "La piattaforma di prenotazione per chi offre servizi",
  title1: "I tuoi servizi.",
  title2: "Si prenotano da soli.",
  sub: "b00k unisce tutti i calendari dei tuoi servizi — camere, auto, appuntamenti — in un unico sistema di prenotazione. I clienti prenotano da soli via web e chat, mentre il sistema sorveglia gli orari e blocca le sovrapposizioni.",
  ctaBook: "Crea un account operatore",
  ctaOperator: "Guarda la vista cliente",
  heroMeta: "LA-TUA-AZIENDA.B00K.ONLINE · OGNI OPERATORE HA IL PROPRIO SOTTODOMINIO",
  cardChip: "Confermata",
  cardNote: "Le prenotazioni arrivano da sole — da web e chat — e bloccano subito l’agenda.",
  catsKick: "CATEGORIE DI SERVIZI",
  catsTitle: "Cosa gestisci con b00k",
  catsSub: "Una piattaforma per tutti i tuoi servizi. Quelli a orario si susseguono; camere e auto si prenotano in parallelo, a giornate.",
  cat1t: "Camere",
  cat1d: "Camere e appartamenti per una o più notti. Più camere si prenotano in parallelo per le stesse date.",
  cat2t: "Auto",
  cat2d: "Citycar e SUV a giornata. Il calendario di disponibilità sorveglia consegne e riconsegne.",
  cat3t: "Attrazioni",
  cat3d: "Sauna, spa, kayak. Prenotazione a un’ora precisa, con durata definita.",
  cat4t: "Parrucchiere",
  cat4d: "Taglio e colore. Scegli l’ora — il sistema blocca esattamente la durata del servizio.",
  cat5t: "Estetica",
  cat5d: "Manicure e massaggi. Combinabili con altri servizi — le durate si fondono in un unico blocco.",
  cat6t: "Sanità",
  cat6d: "Visite ed esami a orario fisso. Il calendario dello studio si tiene in ordine da solo.",
  cat7t: "Officina",
  cat7d: "Auto, bici o portatile — copriamo tutto.",
  cat8t: "Ripetizioni",
  cat8d: "Lezioni di lingua o di piano — gestiscile sulla nostra piattaforma.",
  cat9t: "Altro",
  cat9d: "Le specificità del tuo settore + la nostra esperienza = successo.",
  howKick: "COME FUNZIONA",
  howTitle: "Tre passi, zero telefonate",
  s1t: "Aggiungi servizi e risorse",
  s1d: "Elenca camere, auto e appuntamenti con durate e prezzi. Il sistema verifica ogni account alla registrazione — il tuo e quello dei tuoi clienti.",
  s2t: "I clienti prenotano da soli",
  s2d: "Via web o chat — WhatsApp e Messenger. Le durate si sommano, le camere si prenotano in parallelo e vengono mostrati solo gli orari davvero liberi.",
  s3t: "Il sistema sorveglia l’agenda",
  s3d: "Alla conferma lo slot è bloccato — due persone non possono mai prenotare lo stesso servizio alla stessa ora. Disdette e spostamenti inclusi.",
  newChip: "Novità",
  chatLine: "I tuoi clienti possono prenotare chattando — via WhatsApp o Messenger.",
  opsKick: "PER GLI OPERATORI",
  opsTitle: "La tua agenda lavora per te",
  opsSub: "Camere, auto e appuntamenti in un solo calendario. Le sovrapposizioni si bloccano da sole, le prenotazioni da chat arrivano automaticamente e vedi occupazione e incassi in tempo reale.",
  opsCta: "Guarda il pannello operatore",
  f1: "Calendario giornaliero e occupazione delle risorse in una vista",
  f2: "Blocco automatico delle sovrapposizioni",
  f3: "Prenotazioni da web e chat — WhatsApp / Messenger",
  f4: "Clienti, note sulle prenotazioni e indicatori",
  priceKick: "PREZZI",
  priceTitle: "Semplice come una prenotazione",
  month: "mese",
  recommended: "Consigliato",
  soon: "DISPONIBILE A BREVE",
  custom: "Su misura",
  opsSuffix: "collaboratori",
  priceNote: "Il prezzo mensile dipende da quanti collaboratori hanno accesso al pannello.",
  t1f1: "Calendario e prenotazioni online",
  t1f2: "Chat WhatsApp / Messenger",
  t1f3: "Clienti, note e promemoria",
  t2f1: "Tutto quello di SOLO",
  t2f2: "Risorse e servizi senza limiti",
  t2f3: "Report e indicatori di occupazione",
  t3f1: "Tutto quello di TEAM",
  t3f2: "Turni e ruoli dei collaboratori",
  t3f3: "API e integrazioni",
  t4f1: "Tutto quello di GROUP",
  t4f2: "Supporto all’avvio e SLA",
  t4f3: "Contratto e fatturazione su misura",
  conKick: "CONTATTI E COME ARRIVARE",
  conTitle: "La tua sede, il loro percorso",
  dirKick: "COME ARRIVARE — COSÌ LO VEDRANNO I CLIENTI",
  dir1: "In auto: strada nazionale 3 da Jelenia Góra, uscita Szklarska Poręba Centrum, poi 5 minuti su via Zdrojowa.",
  dir2: "In treno: stazione di Szklarska Poręba Górna, 12 minuti a piedi verso il centro.",
  dir3: "Parcheggio gratuito in loco — senza costi né prenotazione.",
  footUser: "Vista cliente",
  footOp: "Pannello operatore",

  wizTitle: "Crea un account operatore",
  wizSub: "Sette passi. Alla fine avrai il tuo sottodominio e un pannello pronto all’uso.",
  wizStep1: "Azienda",
  wizStep2: "Sottodominio",
  wizStep3: "Settori",
  wizStep4: "Piano",
  wizStep5: "Amministratore",
  wizStep6: "Pagamenti",
  wizStep7: "Riepilogo",
  wizNext: "Avanti",
  wizBack: "Indietro",
  wizFinish: "Crea account",
  fCompany: "RAGIONE SOCIALE",
  fNip: "PARTITA IVA (NIP)",
  fPhone: "TELEFONO",
  fAddress: "INDIRIZZO",
  fSlug: "SOTTODOMINIO",
  slugHint: "L’indirizzo dove i tuoi clienti prenoteranno i servizi.",
  slugChecking: "Verifica della disponibilità…",
  slugFree: "Il sottodominio è libero.",
  slugTaken: "Questo sottodominio è già occupato.",
  slugInvalid: "Sottodominio: 3–63 caratteri, minuscole, cifre e trattino (non all’inizio né alla fine).",
  industriesHint: "Scegli i settori di cui ti occupi. Potrai aggiungerne altri dal pannello.",
  planHint: "Cambi piano quando vuoi — senza perdere dati.",
  fName: "NOME E COGNOME",
  fEmail: "E-MAIL",
  fPass: "PASSWORD (MIN. 8 CARATTERI)",
  fPass2: "RIPETI LA PASSWORD",
  fTerms: "Accetto i termini di b00k.online e acconsento al trattamento dei dati per la gestione delle prenotazioni.",
  payTitle: "Pagamenti dei clienti",
  payHint: "Facoltativo. Puoi incassare online al momento della conferma.",
  payEnable: "Accetta pagamenti online",
  payMethods: "METODI DI PAGAMENTO",
  sumTitle: "Riepilogo",
  sumCompany: "AZIENDA",
  sumSub: "SOTTODOMINIO",
  sumIndustries: "SETTORI",
  sumPlan: "PIANO",
  sumAdmin: "AMMINISTRATORE",
  sumPayments: "PAGAMENTI",
  yes: "Sì",
  no: "No",
  doneTitle: "L’account operatore è pronto",
  doneSub: "Il tuo sottodominio è attivo. Accedi al pannello e aggiungi i servizi — le prenotazioni partono subito.",
  doneOpen: "Apri il pannello operatore",
  doneBooking: "Guarda la pagina di prenotazione",
  companyProofOk: "Accesso come amministratore dell’azienda:",
  companyLoginOther: "Accedi con un altro account",
  errGeneric: "Non siamo riusciti a creare l’account. Controlla i dati e riprova.",
};
